import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { Group } from "@domain/group/group";
import { ContentLicense } from "@domain/licence/contentLicense";
import { useCashable } from "@domain/wallet/hook";
import { PrimaryBold, PrimaryMedium } from "@ui/components/containers/primary";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { WalletIcon } from "@ui/components/icons";
import { InfoBulle } from "@ui/components/infoBulle";
import { row } from "@ui/components/layout";
import { TextSkeleton } from "@ui/components/skeleton/basicSkeletons";

interface ShareroomBalanceProps extends React.HTMLAttributes<HTMLDivElement> {
	license?: ContentLicense;
	shareroom: Group;
}

export const ShareroomBalance: React.FC<ShareroomBalanceProps> = ({ license, shareroom, ...htmlProps }) => {
	//const { result: earning } = useEarning(shareroom.id);
	const { result: cashable } = useCashable(shareroom.id);
	const currentProfile = useCurrentProfile();
	return (
		<Container {...htmlProps}>
			<StyledInfoBulle text={I18n.t("shareroom.dashbaord.balance.information_bubble")} position="top" />
			<IconWrapper>
				<WalletIcon />
			</IconWrapper>
			<Bloc>
				{license === "PREMIUM" && cashable ? (
					<PrimaryBold>
						{cashable?.cashableIUC} {currentProfile?.currency}
					</PrimaryBold>
				) : (
					<TextSkeleton height={10} />
				)}
				<PrimaryMedium>{I18n.t("shareroom.dashboard.transactions.balance.title")}</PrimaryMedium>
			</Bloc>
			{/* <StyledGetBalance>Recevoir mon solde</StyledGetBalance> */}
		</Container>
	);
};

const Container = styled(RoundedBlock)`
	position: relative;
	padding: 30px 44px;
	border: none;
	${row(8, undefined, "center")};
`;

// const StyledGetBalance = styled.div`
// 	position: absolute;
// 	position: absolute;
// 	bottom: 8px;
// 	right: 20px;
// 	font-size: 12px;
//     text-decoration: underline;
// 	cursor: pointer;
//     color: ${({ theme }) => theme.colors.vividBlue};
// `;
const IconWrapper = styled.div`
	flex-shrink: 0;
	border-radius: 50%;
	width: 60px;
	height: 60px;
	background-color: ${({ theme }) => theme.colors.secondaryLight};
	${row(0, "center", "center")};
	> svg {
		width: 32px;
		height: 32px;
	}
`;
const Bloc = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	min-height: 40px;
	gap: 12px;
`;
const StyledInfoBulle = styled(InfoBulle)`
	position: absolute;
	top: 5px;
	right: 3px;
`;
